<template>
<div class="bottom-tips">
  <div class="ctn-uppon"></div>
  <div class="ctn" style="-webkit-app-region: drag;">
    <div class="bottom-tips-left">
      <div class="ctn-border"></div>
      <div class="left-data">
        {{selectedBytes}}
      </div>
    </div>
    <div class="bottom-tips-right">
      <Updater v-show="updaterVisible" @updateDownloaded="updaterVisible = false"
      @checkingUpdateFailed="updaterVisible = false"
      @updateNotAvailable="updaterVisible = false" />
      <div class="right-data"></div>
      <div class="ctn-border"></div>
    </div>
  </div>
  <div class="ctn-below"></div>
</div>
</template>

<script>
import Updater from '../updater/updater.vue'

export default {
  name: "bottomTips",
  components: {
    Updater,
  },
  data() {
    return {
      selectedBytes: "",

      updaterVisible: true,
    }
  },
  mounted() {
    let self = this
    self.env.term.tipsUpdateSelectedBytesAddCallback((selectedBytes) => {
      self.selectedBytes = selectedBytes
    })
  },
}
</script>

<style scoped>
.bottom-tips {
  width: 100%;
  /*如果要修改这个高度，需要同时修改 env/win.js 中 resize() 重置的高度*/
  height: 26px;

  font-size: 0.8em;
  color: #fff;
  background: #3c3c3c;
}
.bottom-tips-left {
  display: flex;
}
.bottom-tips-right {
  display: flex;
}

.ctn-uppon {
  width: 100%;
  height: 3px;
  -webkit-app-region: no-drag;
  /* background-color: #fff; */
}
.ctn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 20px;
  line-height: 20px;
  -webkit-app-region: drag;
}
.ctn-border {
  width: 5px;
  height: 20px;
  -webkit-app-region: no-drag;
  /* background-color: #fff; */
}
.ctn-below {
  width: 100%;
  height: 3px;
  -webkit-app-region: no-drag;
  /* background-color: #fff; */
}
.left-data {
  padding-left: 5px;
}
.right-data {
  padding-right: 5px;
}
</style>